import { render, staticRenderFns } from "./PostIndexSkeleton.vue?vue&type=template&id=5324c1df&"
import script from "./PostIndexSkeleton.vue?vue&type=script&lang=js&"
export * from "./PostIndexSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports